module.exports = __webpack_public_path__ + "static/media/1014373.5ba367ab.jpg";